import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GalleryModule, GalleryConfig } from 'ng-gallery';

import { AppComponent } from './app.component';
import { HomeComponent } from './home.component';
import { AboutComponent } from './about.component';
import { ContactComponent } from './contact.component';
import { ServicesComponent } from './services.component';
import { PortfolioComponent } from './portfolio.component';
import { TestimonialsComponent } from './testimonials.component';
import { GalleryComponent } from './Gallery.component';
import { ApiService } from './shared';

import { removeNgStyles, createNewHosts } from '@angularclass/hmr';

export const galleryConfig: GalleryConfig = {
  style: {
    background: '#121519',
    width: '1200px',
    height: '900px'
  },
  animation: 'fade',
  loader: {
    width: '50px',
    height: '50px',
    position: 'center',
    icon: 'oval'
  },
  description: {
    position: 'bottom',
    overlay: false,
    text: true,
    counter: true
  },
  bullets: null,
  player: {
    autoplay: false,
    speed: 3000
  },
  thumbnails: {},
  navigation: {},
  gestures: true
};

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    GalleryModule.forRoot(galleryConfig),
    RouterModule.forRoot(
      [
          { path: '', component: HomeComponent },
          { path: 'home', component: HomeComponent },
          { path: 'about', component: AboutComponent},
          { path: 'contact', component: ContactComponent},
          { path: 'services', component: ServicesComponent},
          { path: 'portfolio', component: PortfolioComponent},
          { path: 'gallery', component: GalleryComponent},
          { path: 'testimonials', component: TestimonialsComponent}
      ]
    )
  ],
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    ContactComponent,
    ServicesComponent,
    PortfolioComponent,
    GalleryComponent,
    TestimonialsComponent
  ],
  providers: [
    ApiService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(public appRef: ApplicationRef) {}
  hmrOnInit(store) {
    console.log('HMR store', store);
  }
  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.module.ts